import { AxiosRequestConfig } from "axios";
import { RunContextApp } from "framework/RCApp";
import { ApiResponse } from "types";
import {
  EVLoadRefreshStatusAPI,
  GetEVLoadAPI,
  RefreshEVLoadAPI,
} from "types/evLoadManagement/EVLoadManagementInterface";

export const EVLoadManagementAPI = {
  fetchEVLoad: async (
    rc: RunContextApp,
    params: any
  ): Promise<ApiResponse<GetEVLoadAPI.retval>> => {
    const request: AxiosRequestConfig = {};

    const resp = await rc.apiClient.get<GetEVLoadAPI.retval>(
      GetEVLoadAPI.apiEndpoint(params.pilotId),
      request
    );
    return resp;
  },

  evLoadRefreshStatus: async (
    rc: RunContextApp,
    params : EVLoadRefreshStatusAPI.params,
    pilotId: number
  ): Promise<ApiResponse<RefreshEVLoadAPI.retval>> => {

    const request : AxiosRequestConfig = {
      params : params
    } 
    
    const resp = await rc.apiClient.get<EVLoadRefreshStatusAPI.retval>(
      EVLoadRefreshStatusAPI.apiEndpoint(pilotId),
      request
    );

    return resp;
  },

  refreshEVLoad: async (
    rc: RunContextApp,
    pilotId: number
  ): Promise<ApiResponse<RefreshEVLoadAPI.retval>> => {
    
    const resp = await rc.apiClient.post<RefreshEVLoadAPI.retval>(
      RefreshEVLoadAPI.apiEndpoint(pilotId),
    );  

    return resp;
  },
};
